module.exports = __webpack_public_path__ + "img/delete_icon.b989d777.svg";